import { Map, List, fromJS } from 'immutable'
import createReucer from '@/models/createReucer'
import {
  LIST_FETCHED,
  UPDATED,
  TOGGLE_LOADING,
  GROUP_MANAGER_FETCHED
} from './actionTypes'

const initializeState = Map({
  entries: List(),
  fetching: false,
  total: 0
})

export default createReucer({
  [TOGGLE_LOADING]: (state) => state.update('fetching', fetching => !fetching),

  [LIST_FETCHED]: (state, { payload }) => {
    const { total, data } = payload

    return state
      .set('total', total)
      .set('entries', List(fromJS(data)))
  },

  [GROUP_MANAGER_FETCHED]: (state, { payload }) => {
    const { data } = payload
    return state.set('group_manager', List(fromJS(data)))
  },

  [UPDATED]: (state, { payload }) =>
    state.update(
      'entries',
      list => {
        const idx = list.findIndex(item => item.get('_id') === payload.id)
        if (idx === -1) {
          return list
        }
        return list.update(
          idx,
          item => item.merge(payload.data)
        )
      }
    )
}, initializeState)
